/**
 * iter1035 — Reading Level toggle button (feature #3).
 *
 * Compact pill that flips the whole BHI page between "clinical" (default)
 * and "plain" (Explain-Like-I'm-5) reading levels. Reads/writes via
 * `useReadingLevel()` context.
 */
import React from "react";
import { useReadingLevel } from "@/contexts/BhiReadingLevelContext";
import { Lightbulb, GraduationCap } from "lucide-react";

export default function BhiReadingLevelToggle({ isDark = false }) {
  const { level, setLevel } = useReadingLevel();
  const isPlain = level === "plain";

  return (
    <div
      className={`inline-flex rounded-lg border overflow-hidden ${isDark ? "border-slate-700" : "border-slate-300"}`}
      data-testid="bhi-reading-level-toggle"
      title={isPlain ? "Превключи на клиничен език" : "Превключи на разбираем език"}
    >
      <button
        type="button"
        onClick={() => setLevel("clinical")}
        data-testid="bhi-reading-level-clinical"
        className={`px-3 py-1.5 text-xs font-semibold transition inline-flex items-center gap-1.5 ${
          !isPlain
            ? "bg-slate-800 text-white dark:bg-slate-100 dark:text-slate-900"
            : (isDark ? "bg-slate-800 text-slate-300 hover:bg-slate-700" : "bg-white text-slate-600 hover:bg-slate-50")
        }`}
      >
        <GraduationCap className="w-3.5 h-3.5" />
        <span className="hidden sm:inline">Клиничен</span>
      </button>
      <button
        type="button"
        onClick={() => setLevel("plain")}
        data-testid="bhi-reading-level-plain"
        className={`px-3 py-1.5 text-xs font-semibold transition inline-flex items-center gap-1.5 border-l ${isDark ? "border-slate-700" : "border-slate-300"} ${
          isPlain
            ? "bg-amber-500 text-white"
            : (isDark ? "bg-slate-800 text-slate-300 hover:bg-slate-700" : "bg-white text-slate-600 hover:bg-slate-50")
        }`}
      >
        <Lightbulb className="w-3.5 h-3.5" />
        <span className="hidden sm:inline">Разбираем</span>
      </button>
    </div>
  );
}
